import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import Config, { PaginationLimit } from "../../Config";
import moment from "moment";
import { getModeName } from "../../helpers";
import { MdOutlineChevronRight } from "react-icons/md";

const SummaryTable = ({
    apiData,
    setIsViewExpense,
    setSelectedData,
}) => {

    const [data, setData] = useState([
        {
            deviceName: "",
            extractionTime: "",
            processingTime: "",
            drops: "",
            action: "",
        },
    ]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
    const [currentPage, setCurrentPage] = useState(0);
    const [openActionMenu, setOpenActionMenu] = useState(null);
    const toggleRow = (index) => {
        setSelectedRow(selectedRow === index ? null : index);
    };
    const expenses = (item) => {
        setIsViewExpense(true);
        setSelectedData(item)
        setOpenActionMenu(null);
    };

    const ActionBtns = (item) => {
        return (
            <div className="flex gap-4 ">
                <button
                    onClick={() => expenses(item)}
                    className={`cursor-pointer text-sm px-4 py-1 rounded-lg ${' text-gray-600'} flex items-center gap-1`}
                >
                    <MdOutlineChevronRight className="text-gray-300" size={24} />
                </button>
            </div>
        );
    };

    useEffect(() => {
        if (apiData) {
            const tempData = apiData.map((item) => ({
                category: <Category>{item.name}</Category>,
                amount: getAmount(item),
                paymentDate: <span className="text-sm text-gray-600 cursor-pointer" onClick={() => expenses(item)}>{moment(item.paidDate).format("DD-MMM-YY")}</span>,
                paidBy: getPaidBy(item),
                paidTo: <span className="text-sm text-gray-600 cursor-pointer" onClick={() => expenses(item)}>{item.paidToName}</span>,
                paymentMode: getPaymentMode(getModeName(item.paymentMethod)),
                property: item.property,
                repetation: getRepetation(item.repetition),
                action: ActionBtns(item),
                description: item.description,

            }));
            setData(tempData);
        }
    }, [apiData, openActionMenu]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                !event.target.closest("#menuOptions") &&
                !event.target.closest(".action-btn")
            ) {
                setOpenActionMenu(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const getPaymentMode = (value) => {
        let style;
        if (value === "UPI") {
            style = "bg-green-100 text-green-600";
        } else if (value === "Card") {
            style = "bg-lime-100 text-lime-600";
        } else if (value === "Netbanking") {
            style = "bg-blue-100 text-blue-600";
        } else {
            style = "bg-violet-100 text-violet-600";
        }
        return (
            <span className={`${style} px-3 py-1 rounded-md text-sm`} >{value}</span>
        );
    };

    const getRepetation = (repetation) => {
        if (repetation === 1) {
            return <p>One Time</p>;
        } else if (repetation === 2) {
            return <p>Monthly</p>;
        }
    };

    const getAmount = (item) => {
        return <Amount>₹{item.amount}</Amount>
    };
    
    const getPaidBy = (item) => {
        return (
            <UserImageWrapper>

                <div className="flex flex-col text-left">
                    <span className="text-gray-600 text-sm">
                        {item.paidByName}{" "}

                    </span>
                </div>
            </UserImageWrapper>
        );
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 768);
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const columns = React.useMemo(() => {
        if (isMobileView) {

            return [
                {
                    Header: "Paid By",
                    accessor: "paidBy",
                },
                {
                    Header: "Category",
                    accessor: "category",
                },

            ];
        }
        return [
            {
                Header: "Category",
                accessor: "category",
            },
            {
                Header: "Amount",
                accessor: "amount",
            },
            {
                Header: "Paid By",
                accessor: "paidBy",
            },

            {
                Header: "Payment Mode",
                accessor: "paymentMode",
            },
            {
                Header: "Paid On",
                accessor: "paymentDate",
            },
            {
                Header: "",
                accessor: "action",
            },
        ];
    }, [isMobileView]);
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        pageOptions,
        page,
        state: { pageIndex, pageSize },
        previousPage,
        nextPage,
        setPageSize,
        canPreviousPage,
        canNextPage,
    } = useTable(
        {
            data,
            columns,
            initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
        },
        useSortBy,
        usePagination
    );


    useEffect(() => {
        setCurrentPage(pageIndex);
    }, [pageIndex]);

    return (
        <>
            <CustomTable {...getTableProps()}>
                <Thead>
                    {headerGroups.map((headerGroup) => (
                        <Tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                    {column.render("Header")}
                                    <span>
                                        {column.isSorted ? (
                                            <img
                                                src={Images.Arrow}
                                                alt="down arrow"
                                                className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                                                    } w-1.5 inline-block ml-1.5`}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </span>
                                </Th>
                            ))}
                        </Tr>
                    ))}
                </Thead>
                <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
                    {page.map((row, rowIndex) => {
                        prepareRow(row);
                        return (
                            <React.Fragment key={rowIndex}>
                                <Tr {...row.getRowProps({ style: { height: "80px" } })} hasdata={(apiData?.length > 0).toString()}>
                                    {row.cells.map((cell, cellIndex) => {
                                        return (
                                            <Td
                                                {...cell.getCellProps()}
                                                onClick={() => {
                                                    if (
                                                        cellIndex === 0 ||
                                                        (cellIndex === 1 && window.innerWidth < 768)
                                                    ) {
                                                        toggleRow(rowIndex);
                                                    }
                                                }}
                                            >
                                                {cell.render("Cell")}
                                            </Td>
                                        );
                                    })}
                                </Tr>
                                {selectedRow === rowIndex && window.innerWidth < 768 && (
                                    <Tr>
                                        <Td colSpan={columns.length}>
                                            <ul className="flex flex-col gap-2">
                                                <li>
                                                    <strong>Amount:</strong>{" "}
                                                    {data[rowIndex].amount}
                                                </li>
                                                <li>
                                                    <strong>Paid On:</strong>{" "}
                                                    {data[rowIndex].paymentDate}
                                                </li>

                                                <li>
                                                    <strong>Payment Mode:</strong>{" "}
                                                    {data[rowIndex].paymentMode}
                                                </li>

                                                <li>
                                                    <strong>Description:</strong>{" "}
                                                    {data[rowIndex].description}
                                                </li>

                                                <li>
                                                    <strong>Action:</strong> {data[rowIndex].action}
                                                </li>
                                            </ul>
                                        </Td>
                                    </Tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </Tbody>
            </CustomTable>
            {apiData?.length > 0 && (
                <PaginationWrapper>
                    <div className="px-2">
                        Page{" "}
                        <em>
                            {pageIndex + 1} of {pageOptions.length}
                        </em>
                    </div>

                    <div className="flex gap-1">
                        <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
                            <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
                        </PrevBtn>
                        <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
                            <img
                                src={Images.Arrow}
                                alt="arrow"
                                className="w-2 rotate-180 opacity-75"
                            />
                        </NextBtn>
                    </div>
                </PaginationWrapper>
            )}
        </>
    );
};

const CustomTable = tw.table` w-full text-zinc-600`;
const UserImageWrapper = tw.div` flex items-center gap-2`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
    props.hasdata === "true"
        ? "border-b"
        : ""} rounded-md overflow-hidden hover:bg-slate-50 text-gray-800`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-1 text-sm md:p-2 text-left`;
const Amount = tw.p`text-gray-700 text-sm font-medium flex`
const Category = tw.p`text-gray-600 text-sm items-center mt-0.5`
export default SummaryTable;
